import { render } from "./ItemDeleteModal.vue?vue&type=template&id=3cae0636"
import script from "./ItemDeleteModal.vue?vue&type=script&lang=js"
export * from "./ItemDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__